import React from 'react'
import styles from './Spinner.module.css';
import PropTypes from 'prop-types';

function Spinner(props) {
    const { message, showMessage, style} = props;
    const loadingMessage = message || "Please wait...";
    return (
        <div className={styles.SpinnerSection}>
            <span className={styles.Spinner} style={style ? style : null}></span>
            {
                showMessage ? <div className={styles.LoadingMessage}> {loadingMessage} </div> : null
            }
        </div>
    )
}

Spinner.propTypes = {
    showMessage: PropTypes.bool
}

export default Spinner

